// components/CourseViewDialog.tsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { motion } from "framer-motion";

import { ICourseViewDialogProps } from "../types/video-view";
import { getEmbedUrl } from "../utils/GetEmbededUrl";

const CourseViewDialog: React.FC<ICourseViewDialogProps> = ({
  open,
  onClose,
  course,
}) => {
  if (!course) return null;

  const hasVideo = !!course.youtube_url;
  const fallbackImage = "/placeholder.svg";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      component={motion.div}
      // Optional: add nice animation variants if you want
      // initial={{ opacity: 0, scale: 0.95 }}
      // animate={{ opacity: 1, scale: 1 }}
      // exit={{ opacity: 0, scale: 0.95 }}
    >
      <DialogTitle sx={{ px: 3, py: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" component="div">
            Course Preview
          </Typography>
          <IconButton
            onClick={onClose}
            size="small"
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 0, overflow: "hidden" }}>
        <Box sx={{ display: "flex", height: "70vh" }}>
          {/* Main content area (video or image) */}
          <Box
            sx={{
              flex: 1,
              bgcolor: "#000",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {hasVideo ? (
              <iframe
                src={getEmbedUrl(course.youtube_url!)}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
                title={course.title}
              />
            ) : (
              <img
                src={course.image ?? fallbackImage}
                alt={course.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
                onError={(e) => {
                  e.currentTarget.src = fallbackImage;
                }}
              />
            )}
          </Box>

          {/* Sidebar with course info */}
          <Box
            sx={{
              width: 360,
              bgcolor: "#f8f9fa",
              borderLeft: "1px solid",
              borderColor: "divider",
              overflowY: "auto",
            }}
          >
            <Box sx={{ p: 3 }}>
              <Typography variant="h5" gutterBottom>
                {course.title}
              </Typography>

              {course.description && (
                <Typography variant="body1" color="text.secondary" paragraph>
                  {course.description}
                </Typography>
              )}

            </Box>

            <Divider />

            {/* <Box sx={{ p: 3 }}>
              <Typography variant="subtitle2" gutterBottom>
                Lessons
              </Typography>
              ...
            </Box> */}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CourseViewDialog;